import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '~/components/Dialog'
import IndividualFiltersQuery from '~/QueryHooks/IndividualFiltersQuery'
import { FilterEnums } from './types'
import TableComponent from '~/components/TableComponent'

interface Props {
  type: FilterEnums
  isOpen: boolean
  handleClose: () => void
}

const NotAssignedModal:React.FC<Props> = (props) => {
  const { type, isOpen, handleClose } = props
  const { t } = useTranslation()

  const [dataFiltered, setDataFiltered] = useState({
    rows: 10,
    page: 0
  })

  const tableColumnHeaders = [
    {
      name: t('Supplier No.'),
      key: 'supplierNo'
    },
    {
      name: t('Company name'),
      key: 'companyName'
    }
  ]
 
  const {
    data: farmers,
    isLoading: isLoadingFarmers,
    refetch: fetchFarmers,
    isFetching: isFetchinFarmers
  } = IndividualFiltersQuery.getNotAssignedFarmers(
    isOpen,
    type,
    {
      ...dataFiltered,
      page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
    }
  )

  useEffect(() => {
    if(isOpen) {
      fetchFarmers()
    }
  }, [dataFiltered])

  function renderTable() {
    return <TableComponent
      tableColumnHeaders={tableColumnHeaders}
      animated
      isFetchingData={isFetchinFarmers}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      total={filtered}
      rows={rows}
    />
  }

  const { filtered, rows } = farmers ? farmers : { filtered: 0, rows: [] };

  return <Dialog
    isDialogOpen={isOpen}
    handleClose={() => handleClose()}
    isLoading={isLoadingFarmers}
    minHeight='640px'
    textContent={<>
      {renderTable()}
    </>}
    textHeader={t('Not assigned')}
    textClose={t('Close')}
  />
}
export default NotAssignedModal